import styled from 'styled-components';
import { color } from 'styles/pallete';
import { svg } from 'utils/imgList';

export const container = styled.div`
	width: 100%;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	background-image: url(${svg.loginBackground});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;

	> img {
		height: 50px;
		margin-bottom: 3rem;
	}
`;

export const loginBox = styled.div`
	width: 20vw;
	min-width: 300px;
	margin-bottom: 1.5rem;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 1.5rem;

	padding: 4.5rem 3rem 4.5rem 3rem;
	background-color: ${color.interface.white};
	border-radius: 5px;

	-webkit-box-shadow: 0px 0px 18px -11px #000000;
	box-shadow: 0px 0px 18px -11px #000000;

	> h1 {
		align-self: center;
		color: ${color.interface.darkgray};
		font-family: nunito-bold;
		font-size: 2rem;
	}
`;

export const rememberMe = styled.div`
	width: 100%;
	display: flex;
	gap: 0.8rem;
	align-items: center;
	justify-content: flex-start;

	p {
		color: ${color.interface.lightGray};
		font-family: nunito-bold;
		font-weight: 800;
	}
`;

export const btnLogin = styled.div`
	width: 100%;
	cursor: pointer;
	margin-top: 1rem;
	> button {
		all: unset;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 1rem;
		color: ${color.interface.white};
		width: 100%;
		background-color: ${color.interface.blue1};
		border-radius: 5px;
		font-size: 1.5rem;
		transition: all ease 0.5s;
	}

	> button:hover {
		opacity: 0.8;
	}
`;

export const forgotPassword = styled.div`
	display: flex;
	gap: 1rem;
	align-items: center;
	> p {
		cursor: pointer;
		font-size: 1.5rem;
		color: ${color.interface.lightGray};
	}
`;

export const singUp = styled.div`
	margin-top: 1.5rem;
	display: flex;
	gap: 0.5rem;
	> p,
	b {
		cursor: pointer;
		font-size: 1.5rem;
		color: ${color.interface.lightGray};
	}
`;

export const errorMessage = styled.span`
	color: ${color.interface.red};
	font-size: 1.2rem;
	font-weight: 900;
`;
